<template>
	<section class="Upload">
		<div
			class="drag-area"
			@drop.prevent.stop="onFileDrop"
			@dragleave.prevent="dragging = false"
			@dragenter.prevent="dragging = true"
			@dragover.prevent="dragging = true"
			@dragend.prevent="dragging = false"
			:class="{ dragging: dragging }"
			:style="url ? { '--image': `url(${url})` } : {}"
		>
			<i :style="{ visibility: !!url ? 'hidden' : 'visible'}" class="icon-cloud-upload"></i>
			<span v-if="!!url">
				<!-- {{ url }} -->
			</span>
			<template v-else>
				<span>ファイルをドロップ</span>
				<span>又は</span>
			</template>
		</div>
		<Button class="upload" @click="uploadImage()" :disabled="!!url">アップロード</Button>
	</section>
</template>

<script>
	import { uploadFileReact } from '../../common/libs/file';

	export default {
		data() {
			return {
				dragging: false,
				url: ''
			};
		},
		props: ['data'],
		methods: {
			onFileDrop(e) {
				e.preventDefault();
				this.uploadImage(e.dataTransfer.files[0]);
				this.dragging = false;
			},

			async uploadImage(file) {
				const url = await uploadFileReact(file, this.data, this.$store.state.user?.access_key);
				this.url = url;
				this.$emit('upload', url);
			}
		}
	};
</script>

<style scoped lang="scss">
	.Upload {
		padding: 1rem 1.6rem;
		.drag-area {
			padding: 1rem;
			border: dashed 1px rgba(0, 0, 0, 0.1);
			display: flex;
			flex-direction: column;
			align-items: center;
			color: #ddd;
			background-image: var(--image, none);
			background-size: cover;
			background-position: center;

			i,
			span {
				pointer-events: none;
			}

			input {
				display: none;
			}

			&.dragging {
				background-color: #ccc;
				color: #888;
			}

			& > * {
				&:not(:first-child) {
					margin-top: 1rem;
				}
			}

			i {
				font-size: 6rem;
			}
		}

		.Button.upload {
			width: 100%;
			margin-top: 1rem;
		}
	}
</style>
